import * as _ from "lodash-es";
import * as qs from "query-string";
import React, { Component } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import dhlLogo from "../../../assets/images/company_logos/dhl-logo.png";

import fedexLogo from "../../../assets/images/company_logos/fedex-logo.png";
import tntLogo from "../../../assets/images/company_logos/tnt-logo.png";
import upsLogo from "../../../assets/images/company_logos/ups-logo.png";
import uspsLogo from "../../../assets/images/company_logos/usps-logo.png";
import shipstationGear from "../../../assets/images/shipstation/shipstation-gear.png";
import IDeleteShipmentGroupDTO from "../../../models/DTO/IDeleteShipmentGroupDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnDeleteShipmentGroupDTO from "../../../models/DTO/IOnDeleteShipmentGroupDTO";
import IOnQBODeleteInvoiceDTO from "../../../models/DTO/IOnQBODeleteInvoiceDTO";
import IOnQBOVoidInvoiceDTO from "../../../models/DTO/IOnQBOVoidInvoiceDTO";
import IOnShipmentCaptureSignatureDTO from "../../../models/DTO/IOnShipmentCaptureSignatureDTO";
import IOnShipstationVoidLabelDTO from "../../../models/DTO/IOnShipstationVoidLabelDTO";
import IOnVoidShipmentDTO from "../../../models/DTO/IOnVoidShipmentDTO";
import IQBOCreateInvoiceDTO from "../../../models/DTO/IQBOCreateInvoiceDTO";
import IQBODeleteInvoiceDTO from "../../../models/DTO/IQBODeleteInvoiceDTO";
import IQBOVoidInvoiceDTO from "../../../models/DTO/IQBOVoidInvoiceDTO";
import IShipmentCaptureSignatureDTO from "../../../models/DTO/IShipmentCaptureSignatureDTO";
import IShipstationVoidLabelDTO from "../../../models/DTO/IShipstationVoidLabelDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import GoogleMapsMarkerSizeEnum from "../../../models/Google Maps/GoogleMapsMarkerSizeEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import IOwTableCols from "../../../models/IOwTableCols";
import IShipment from "../../../models/IShipment";
import IShipment_Group from "../../../models/IShipment_Group";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import IShipmentUI from "../../../models/IShipmentUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderSourceEnum from "../../../models/OrderSourceEnum";

import ShipmentStatusEnum from "../../../models/ShipmentStatusEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import SocketService from "../../../services/SocketService";

import UserService from "../../../services/UserService";
import VendorService from "../../../services/VendorService";

import ViewAccessService from "../../../services/ViewAccessService";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import BetaBadge from "../../shared/BetaBadge/BetaBadge";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import CaptureSignatureModal from "../../shared/CaptureSignatureModal/CaptureSignatureModal";
import OrderPayment from "../../shared/OrderPayment/OrderPayment";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";

import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import { QBOInvoiceActions } from "../../shared/QBOInvoiceActions/QBOInvoiceActions";
import { ViewPayment } from "../../shared/ViewPayment/ViewPayment";
import ViewSignatureModal from "../../shared/ViewSignatureModal/ViewSignatureModal";

import { QuickBooksOnlineInvoiceSidebar } from "../../shared/QuickBooksOnlineInvoiceSidebar/QuickBooksOnlineInvoiceSidebar";
import PdfSidebarViewer from "../../shared/PdfSidebarViewer/PdfSidebarViewer";
import ShipmentPackageSidebar from "../ShipmentPackageSidebar/ShipmentPackageSidebar";
import "./Shipments.scss";

import ShipmentTracking from "./ShipmentTracking/ShipmentTracking";
import VoidLabelsModal from "./VoidLabelsModal/VoidLabelsModal";
import IWayfairAcknowledgeShippingForPoDTO from "../../../models/DTO/IWayfairAcknowledgeShippingForPoDTO";
import IWayfairOnAcknowledgeShippingForPoDTO from "../../../models/DTO/IWayfairOnAcknowledgeShippingForPoDTO";
import { FishbowlDownloadShipmentsModal } from "./FishbowlDownloadShipmentsModal/FishbowlDownloadShipmentsModal";

import { Socket } from "socket.io-client";
import { ShipmentGroupSidebarFn } from "../ShipmentGroupSidebarFn/ShipmentGroupSidebarFn";
import IDeleteShipmentDTO from "../../../models/DTO/IDeleteShipmentDTO";
import IQBOOnGetPDFInvoiceDTO from "../../../models/DTO/IQBOOnGetPDFInvoiceDTO";
import { OwFnTable } from "../../shared/OwFnTable/OwFnTable";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { ShipmentFilterFn } from "./ShipmentFilterFn/ShipmentFilterFn";
import { ShipmentsFilterBar } from "./ShipmentsFilterBar/ShipmentsFilterBar";
import { FilterBarVersionToggle } from "../../shared/FilterBarVersionToggle/FilterBarVersionToggle";
import { getFilterBarMode } from "@utils/filterBarVersion";
import { ConfirmDeleteShipmentModal } from "./ConfirmDeleteShipmentModal/ConfirmDeleteShipmentModal";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IResendShipmentEmailDTO from "../../../models/DTO/IResendShipmentEmailDTO";
import IOnResendShipmentEmailDTO from "../../../models/DTO/IOnResendShipmentEmailDTO";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { IUiContextModel } from "@contexts/UiContext";

type Props = {
    location: any;
    history: any;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    getSidebarState: () => boolean;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    isReadOnly: boolean;
    uiContext: IUiContextModel;
    /** Rendered under `/ecomm/shipments`: always the legacy search section, no FilterBar toggle. */
    isEcommerce?: boolean;
};

type State = {
    shipmentGroups: IShipment_GroupUI[];
    showVoided: boolean;
    selectedShipment: IShipment | null;
    selectedShipmentElem: any;
    selectedShipmentGroup: IShipment_Group | null;
    isLoadingShipments: boolean;
    limit: number;
    offset: number;
    totalShipments: any;
    activeCreateInvoice: { [key: string]: boolean };
    disableCreateInvoice: { [key: string]: boolean };
    activeViewInvoice?: { [key: string]: boolean };
    disableViewInvoice?: { [key: string]: boolean };
    orderFilter?: string;
    hasAction?: boolean;
    action?: any;
    overlayRow: any;
    vendorModel?: IVendorModel;
    navItems?: IBreadcrumbs[];
    queryString?: any;
    showHiddenFeatures?: any;
    shipments?: any[];
    totalShipmentGroups?: number;
    delete_shipstation_order?: boolean;
    createShipmentGroup?: boolean;
    selectedShipmentElemIndex?: number;
    hasEditMode: boolean;
    columns: IOwTableCols[];
    detailViewColumns: IOwTableCols[];
    isInitialData: boolean;
    isDataFetching: boolean;
    modalComponent: any;
    modalIsOpen: boolean;
    sourceGroupElem: HTMLElement | null;
    wayfairIsActive: boolean;
    wayfairShipmentGroupRow: string;
    targetElem: string | null;
    resendEmailActive: boolean;
};

class Shipments extends Component<Props, State> {
    deleteIndex?: number;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.openShipmentGroupSidebar = this.openShipmentGroupSidebar.bind(this);
        this.cancel = this.cancel.bind(this);
        this.onVoidShipment = this.onVoidShipment.bind(this);

        this.getShipmentGroupSidebar = this.getShipmentGroupSidebar.bind(this);

        document.title = `Orderwerks >> Shipments`;

        const action = this.parseUrlForActions();
        const orderFilterParsed = this.parseUrlForFilter();
        const orderFilter = _.isString(orderFilterParsed) ? orderFilterParsed : "";

        const columns: IOwTableCols[] = [
            {
                hasChevron: true,
                showChevronFn: this.rowHasChevronFn,
                title: "",
                valueProp: "",
                renderFn: this.renderActions,
                renderFnEmitsRow: true,
                isActionsCol: true,
            },
        ];

        if (this.props.userModel.isSupplierUser) {
            columns.push({
                title: "vendor",
                valueProp: "Vendor",
                valueSubProp: "name",
                isVendorOverride: true,
            });
        }

        columns.push(
            {
                title: "orders",
                valueProp: "",
                renderFn: this.renderOrders,
                renderFnEmitsRow: true,
            },
            {
                title: "pos",
                valueProp: "",
                renderFn: this.renderPOs,
                renderFnEmitsRow: true,
            },
            {
                title: "ship_to",
                valueProp: "",
                renderFn: this.renderShipTo,
                renderFnEmitsRow: true,
            },
            {
                title: "bill_to",
                valueProp: "",
                renderFn: this.renderBillTo,
                renderFnEmitsRow: true,
            },
            {
                title: "",
                valueProp: "",
                renderFn: this.renderActionBtns,
                renderFnEmitsRow: true,
            }
        );

        const detailViewColumns: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.renderDetailViewActions,
                renderFnEmitsRow: true,
            },
            {
                title: "ship_date",
                valueProp: "",
                renderFn: this.renderShipDate,
                renderFnEmitsRow: true,
            },
            {
                title: "carrier",
                valueProp: "",
                renderFn: this.renderCarrier,
                renderFnEmitsRow: true,
            },
            {
                title: "status",
                valueProp: "",
                renderFn: this.renderShipmentStatus,
                renderFnEmitsRow: true,
            },
            {
                title: "tracking",
                valueProp: "",
                renderFn: this.renderTracking,
                renderFnEmitsRow: true,
            },
        ];

        if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) {
            detailViewColumns.push({
                title: "price",
                valueProp: "",
                renderFn: this.renderShipmentPrice,
                renderFnEmitsRow: true,
            });
        }

        detailViewColumns.push({
            title: "note",
            valueProp: "",
            renderFn: this.renderNote,
            renderFnEmitsRow: true,
        });

        if (this.props.supplierModel.has_pick_list_management && this.props.userModel.isSupplierUser) {
            detailViewColumns.push({
                title: "packing_list",
                valueProp: "",
                renderFn: this.renderPackingList,
                renderFnEmitsRow: true,
            });
        }

        if (
            this.props.userModel.isSupplierUser &&
            (this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT ||
                this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT)
        ) {
            detailViewColumns.push({
                title: "",
                valueProp: "",
                renderFn: this.renderShipmentBtns,
                renderFnEmitsRow: true,
            });
        }

        const paramsState = this.getParamsState(this.props.location);

        const userTypeName = _.get(this.props.userModel, "userType.name");

        console.log("action: ", action);

        this.state = {
            shipmentGroups: [],
            showVoided: false,
            selectedShipment: null,
            selectedShipmentElem: null,
            selectedShipmentGroup: {} as IShipment_Group,
            isLoadingShipments: true,
            limit: paramsState.limit,
            offset: paramsState.offset,
            totalShipments: null,
            activeCreateInvoice: {},
            disableCreateInvoice: {},
            orderFilter: orderFilter || "",
            hasAction: !_.isNil(action),
            action,
            overlayRow: null,
            // @ts-expect-error
            hasEditMode: !this.props.isReadOnly,
            isInitialData: true,
            isDataFetching: false,
            columns,
            detailViewColumns,
            modalIsOpen: false,
            modalComponent: null,
            sourceGroupElem: null,
            wayfairIsActive: false,
            wayfairShipmentGroupRow: "",
            targetElem: null,
            resendEmailActive: false,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.ShipmentOnGetShipmentGroups, fn: this.onGetShipmentGroups },
            { endpoint: EndpointsEnum.ShipmentOnDeleteShipment, fn: this.onDeleteShipment },
            { endpoint: EndpointsEnum.ShipmentOnVoidShipment, fn: this.onVoidShipment },
            { endpoint: EndpointsEnum.ShipmentOnUpdateShipmentStatus, fn: this.onUpdateShipmentStatus },
            { endpoint: EndpointsEnum.QBOOnCreateInvoice, fn: this.onQboCreateInvoice },
            { endpoint: EndpointsEnum.QBOOnGetPDFInvoice, fn: this.onQboGetPdfInvoice },
            { endpoint: EndpointsEnum.ShipmentOnDeleteShipmentGroup, fn: this.onDeleteShipmentGroup },
            { endpoint: EndpointsEnum.ShipstationOnVoidLabel, fn: this.onVoidShipstationLabel },
            { endpoint: EndpointsEnum.QBOOnVoidInvoice, fn: this.onVoidQboInvoice },
            { endpoint: EndpointsEnum.QBOOnDeleteInvoice, fn: this.onDeleteQboInvoice },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.ShipmentGroupOnCaptureSignature, fn: this.onCaptureSignature },
            { endpoint: EndpointsEnum.WayfairOnAcknowledgeShippingForPurchaseOrder, fn: this.onWayfairAcknowledgeShippingForPurchaseOrder },
            { endpoint: EndpointsEnum.ShipmentOnResendShipmentEmail, fn: this.onResendShipmentEmail },
        ];

        // This is being controlled by the Shipment Filter
        // this.props.history.listen((location: any) => {
        //     const paramsState = this.getParamsState(location);
        //
        //     const existingQueryString = this.state.queryString;
        //
        //     const queryString = this.getQueryString(paramsState);
        //
        //     this.setState(
        //         {
        //             queryString,
        //         },
        //         () => {
        //             console.log("shipment location change search: ", this.state.queryString);
        //             if (existingQueryString != this.state.queryString) {
        //                 console.log("shipment location change search: ", this.state.queryString);
        //                 this.getShipmentGroups();
        //             }
        //         }
        //     );
        // });
    }

    async componentDidMount() {
        const vendorModel = this.props.vendorModel;

        this.setState(
            {
                vendorModel,
            },
            () => {
                for (const socket of this.sockets) {
                    this.props.socket.on(socket.endpoint, socket.fn);
                }

                if (this.state.hasAction) {
                    if (this.state.action.type === "new_shipment") {
                        // get the vendor details from API
                        // get the order details from the API

                        const shipment = {
                            action: this.state.action,
                        };

                        // @ts-expect-error
                        this.openShipmentGroupSidebar(shipment);
                    }
                }

                if (this.usesFilterBarV2()) {
                    // The FilterBar runs the initial search (default preset / baseline / deep link).
                } else if (this.state.orderFilter?.length) {
                    const state: any = {
                        queryString: `?order=${this.state.orderFilter}`,
                    };

                    this.setState(state, () => {
                        this.getShipmentGroups();
                    });
                } else {
                    const state: any = {
                        queryString: `?hide_signed=true`,
                    };

                    this.setState(state, () => {
                        this.getShipmentGroups();
                    });
                }
            }
        );
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (!this.state.showHiddenFeatures) {
            // console.log('window', window);

            // @ts-expect-error
            if (!_.isNil(window.showHiddenFeatures)) {
                this.setState({
                    showHiddenFeatures: true,
                });
            }
        }
    }

    componentWillUnmount() {
        this.props.toggleSidebar(false);

        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    notify = () => {
        const activeViewInvoice = this.state.activeViewInvoice;

        if (activeViewInvoice) {
            for (const activeView of Object.keys(activeViewInvoice)) {
                activeViewInvoice[activeView] = false;
            }
        }

        this.setState({
            activeViewInvoice,
            wayfairIsActive: false,
            wayfairShipmentGroupRow: "",
            isDataFetching: false,
        });
    };

    rowHasChevronFn = (row: IShipment_GroupUI) => {
        if (row.is_local_delivery || row.is_local_pickup) {
            return false;
        } else {
            return true;
        }
    };

    onResendShipmentEmail = (data: IOnResendShipmentEmailDTO) => {
        const notification: INotification = {
            message: "successfully_resent_email",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            resendEmailActive: false,
        });
    };

    renderActions = (row: IShipment_GroupUI, index: number) => {
        const sideBarOpenIcon = "fa-pencil";

        const shippingCarrierName: string = _.get(row, "Shipping_Carrier.name", "");

        // if (!_.isNil(row.shipstation_carrierCode)) {
        //     shippingCarrierName = row.shipstation_carrierCode;
        //     // sideBarOpenIcon = 'fa-eye';
        // }

        switch (shippingCarrierName) {
            case "FEDEX":
            case "UPS":
            case "DHL":
            case "TNT":
                // shippingCarrierName = _.startCase(_.toLower(shippingCarrierName));
                break;
        }

        let shipmentStatus = _.get(row, "Shipment_Status.name", "");

        shipmentStatus = shipmentStatus.replace("_", " ");
        shipmentStatus = _.startCase(_.toLower(shipmentStatus));

        const vendor_name = _.get(row, "Vendor.name", "");

        const packages = this.getPackages(row);

        let shipstationDetail: any = null;

        let isShipstationPackage = _.get(row, "shipstation_order_id", false);
        isShipstationPackage = !_.isNil(isShipstationPackage) ? isShipstationPackage : false;

        if (isShipstationPackage) {
            shipstationDetail = <img className={"ms-4"} src={shipstationGear} height={20} title={"ShipStation"} />;
        }

        let localPickupDetail: any = null;

        let isLocalPickup = _.get(row, "is_local_pickup", false);
        isLocalPickup = !_.isNil(isLocalPickup) ? isLocalPickup : false;

        if (isLocalPickup) {
            localPickupDetail = <i className={"ms-4 fad fa-hand-holding-box text-warning fa-lg"} title={"Local Pickup"} />;
        }

        let localDeliveryDetail: any = null;

        let isLocalDelivery = _.get(row, "is_local_delivery", false);
        isLocalDelivery = !_.isNil(isLocalDelivery) ? isLocalDelivery : false;

        if (isLocalDelivery) {
            localDeliveryDetail = <i className={"ms-4 fad fa-truck text-warning fa-lg"} title={"Local Delivery"} />;
        }

        let dropshipmentDetail: any = null;

        let isDropshipment = _.get(row, "is_dropshipment", false);
        isDropshipment = !_.isNil(isDropshipment) ? isDropshipment : false;

        if (isDropshipment) {
            dropshipmentDetail = <i className={"ms-4 fad fa-parachute-box text-warning fa-lg"} title={"Dropshipment"} />;
        }

        let quickBooksIcons: any = null;

        if (row.qbo_InvoiceId) {
            quickBooksIcons = (
                <span>
                    <i className={"ms-4 fad fa-envelope fa-lg " + (row.qbo_InvoiceSent ? "text-success" : "text-muted")} title={"Sent"} />
                    <i
                        className={"ms-4 fad fa-dollar-sign fa-lg " + (row.qbo_InvoicePaid ? "text-success" : "text-muted")}
                        title={"Marked As Paid"}
                    />
                </span>
            );
        }

        let hideEdit = !this.state.hasEditMode;
        let hideTrash = true;

        if (this.props.userModel && this.props.userModel.isSupplierUser) {
            // do we need to check that the user has edit access?

            if (this.props.userModel.userType?.id === UserTypesEnum.ADMIN) {
                hideTrash = false;
            }
        } else {
            hideEdit = true;
        }

        return (
            <div className={"d-flex align-items-center no-wrap"}>
                <span className={"state-circle me-4 " + (row.isSaved ? "bluish-green-bg" : "red-bg")} />
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={(e) => {
                        this.toggleConfirmDelete(e, row, index);
                    }}
                    onEditClickFn={() => {
                        this.openShipmentGroupSidebar(row, index);
                    }}
                    hideEdit={hideEdit}
                    hideTrash={hideTrash}
                />

                {/*{this.state.hasEditMode ? (*/}
                {/*    <a*/}
                {/*        href="javascript:;"*/}
                {/*        role="button"*/}
                {/*        className={*/}
                {/*            `fad pointer ${sideBarOpenIcon}` +*/}
                {/*            (this.props.userModel && this.props.userModel.isSupplierUser ? " " : " d-none")*/}
                {/*        }*/}
                {/*        onClick={() => {*/}
                {/*            this.openShipmentGroupSidebar(row, index);*/}
                {/*        }}*/}
                {/*    />*/}
                {/*) : null}*/}

                {/*<span className={""}>*/}
                {/*    <a*/}
                {/*        href="javascript:;"*/}
                {/*        role="button"*/}
                {/*        className={*/}
                {/*            `fas pointer fa-trash-alt ms-4 text-danger` +*/}
                {/*            (this.props.userModel &&*/}
                {/*            this.props.userModel.isSupplierUser &&*/}
                {/*            this.props.userModel.userType?.id === UserTypesEnum.ADMIN*/}
                {/*                ? " "*/}
                {/*                : " d-none")*/}
                {/*        }*/}
                {/*        onClick={(e) => {*/}
                {/*            this.toggleConfirmDelete(e, row, index);*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</span>*/}
                {shipstationDetail}
                {localPickupDetail}
                {localDeliveryDetail}
                {dropshipmentDetail}
                {quickBooksIcons}
            </div>
        );
    };

    renderPOs = (row: IShipment_GroupUI) => {
        if (row.Orders) {
            const poNos = (row.Orders || []).map((order: IOrder, orderIndex: number) => {
                if (order) {
                    return order.po_no || "";
                } else {
                    return "";
                }
            });

            return <div>{poNos.join(", ")}</div>;
        } else {
            return "";
        }
    };

    renderOrders = (row: IShipment_GroupUI) => {
        const order_ids = (row.Orders || []).map((order: IOrder, orderIndex: number) => {
            let ids;

            const order_guid = _.get(order, "guid", undefined);

            if (_.isNil(order_guid) || order_guid === "") {
                return "Missing Attached Orders";
            }

            if (this.props.userModel.isVendorSourceUser) {
                return <div key={order.guid}>{order.name}</div>;
            }

            if (orderIndex < row.Orders!.length - 1) {
                ids = (
                    <span key={orderIndex}>
                        <div>
                            <Link to={`/orders/${order_guid}/entry`}>{order.name}</Link>
                            {order.Contact ? (
                                <div>
                                    <div>{order.Contact.name}</div>
                                    <div>
                                        <OwLabel title={"phone"} postText={":"} className={"me-2"} isBold={true} />
                                        {order.Contact.phone}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </span>
                );
            } else {
                ids = (
                    <div>
                        <Link key={orderIndex} to={`/orders/${order_guid}/entry`}>
                            {order.name}
                        </Link>
                        {order.Contact ? (
                            <div>
                                <div>{order.Contact.name}</div>
                                <div>
                                    <OwLabel title={"phone"} postText={":"} className={"me-2"} isBold={true} />
                                    {order.Contact.phone}
                                </div>
                            </div>
                        ) : null}
                    </div>
                );
            }

            return ids;
        });

        return order_ids;
    };

    renderShipTo = (row: IShipment_GroupUI) => {
        return row.is_local_pickup ? (
            <div>
                <OwLabel title={"local_pickup"} />
            </div>
        ) : (
            <div className={"d-flex"}>
                {this.props.supplierModel.has_google_maps ? (
                    <OwGoogleStaticMap
                        address={row.Ship_To!}
                        size={"120x120"}
                        zoomLevel={12}
                        className={"me-2"}
                        markerSize={GoogleMapsMarkerSizeEnum.TINY}
                    />
                ) : null}
                <AddressDisplay showName={true} showCompanyName={true} address={row.Ship_To} prefix={""} />
            </div>
        );
    };

    renderBillTo = (row: IShipment_GroupUI) => {
        if (row.is_local_pickup) {
            return <div>--</div>;
        } else {
            if (row.bill_to_same_as_ship_to) {
                return <OwLabel title={"same_as_ship_to"} />;
            } else {
                return <AddressDisplay showName={true} address={row.Bill_To} prefix={""} />;
            }
        }
    };

    captureSignatureFn = (shipmentGroupGuid: string, vendorGuid: string, name: string, mark_picked_up: boolean, jpgObj: any) => {
        const payload: IShipmentCaptureSignatureDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid,
            signature: name,
            shipmentGroupGuid,
            signatureImage: jpgObj,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGroupCaptureSignature, payload);
    };

    onCaptureSignature = (data: IOnShipmentCaptureSignatureDTO) => {
        this.closeModal();
        this.getShipmentGroups();
    };

    sendWayfairShipNotification = (row: IShipment_GroupUI) => {
        if (row.Orders?.length === 1) {
            const orderGuid = row.Orders[0].guid;

            const payload: IWayfairAcknowledgeShippingForPoDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid,
                shipmentGroupGuid: row.guid,
            };

            this.props.socket.emit(EndpointsEnum.WayfairAcknowledgeShippingForPurchaseOrder, payload);

            this.setState({
                wayfairIsActive: true,
                wayfairShipmentGroupRow: row.guid,
            });
        }
    };

    onWayfairAcknowledgeShippingForPurchaseOrder = (data: IWayfairOnAcknowledgeShippingForPoDTO) => {
        const notification: INotification = {
            message: "successfully_acknowledged_shipping_for_purchase_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                wayfairIsActive: false,
                wayfairShipmentGroupRow: "",
            },
            () => {
                this.getShipmentGroups();
            }
        );
    };

    showSignatureModal = (row: IShipment_GroupUI, isCapture: boolean) => {
        let component: any;

        if (isCapture) {
            component = (
                <CaptureSignatureModal
                    closeModalFn={this.closeModal}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    shipmentGroup={row}
                    captureSignatureFn={this.captureSignatureFn}
                />
            );
        } else {
            component = <ViewSignatureModal closeModalFn={this.closeModal} shipmentGroup={row} />;
        }

        this.props.uiContext.setModalComponent(component);
        this.props.uiContext.showModal();
    };

    openPaymentsModel = (row: IShipment_GroupUI) => {
        if (row.Orders) {
            const modalComponent = (
                <div className={"p-3"}>
                    <OrderPayment
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        orderModel={row.Orders[0]}
                        setActivityIndicator={this.props.setActivityIndicator}
                        socket={this.props.socket}
                        notifyFn={this.props.notifyFn}
                        cancelFn={this.closeModal}
                        confirmFn={this.closeModal}
                    />
                </div>
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        }
    };

    viewPayment = (row: IShipment_GroupUI) => {
        if (row.Orders?.length) {
            const payment = row.Orders![0].Payments![0];

            const modalComponent = (
                <ViewPayment
                    closeModalFn={this.closeModal}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    orderModel={row.Orders![0]}
                    payment={payment}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        }
    };

    renderActionBtns = (row: IShipment_GroupUI) => {
        const has_qbo = _.get(this.props.supplierModel, "Supplier_Integration.has_qbo", false);
        let createInvoiceArea = _.get(this.props.supplierModel, "create_invoice_area", "shipments");
        createInvoiceArea = _.isNil(createInvoiceArea) ? "shipments" : createInvoiceArea;

        const orderGuids = row.Orders?.map((orderMapItem) => orderMapItem?.guid) || [];

        let shippingButtons: any = null;
        let quickBooksButtons: any = null;
        let qbPaymentsButtons: any = null;
        let bolButton: any =
            this.props.supplierModel.has_bill_of_lading && orderGuids.length ? (
                <div className={"mt-2"}>
                    <Link to={`/orders/bill_of_lading?orders=${orderGuids.join(",")}`}>
                        <OwButton className={"btn-warning mb-2 mb-md-0"} title={"bill_of_lading"} leftIconClass={"far fa-receipt"} />
                    </Link>
                </div>
            ) : null;
        let packingListButton: any = orderGuids.length ? (
            <div className={"mt-2"}>
                <Link to={`/shipments/packing_list?orders=${orderGuids.join(",")}`}>
                    <OwButton className={"btn-warning mb-2 mb-md-0"} title={"packing_list"} leftIconClass={"far fa-list-alt"} />
                </Link>
            </div>
        ) : null;

        if (this.props.supplierModel.has_pick_list_management) {
            packingListButton = null;
        }

        if (has_qbo) {
            const has_invoice = !_.isNil(row.qbo_InvoiceId);
            const shouldHidePricing = this.shouldHidePricing();

            const has_qbp = this.props.supplierModel.Supplier_Integration.has_qbo_payments;

            if (has_qbp && row.Orders?.length === 1 && row.Vendor?.require_payment) {
                // we currently only support 1 order with QB Payments
                if (row.Orders[0].Payments?.length === 0) {
                    qbPaymentsButtons = (
                        <div className={"mb-2"}>
                            <OwButton
                                disabled={has_qbo && !has_invoice}
                                title={"payment"}
                                fn={() => {
                                    this.openPaymentsModel(row);
                                }}
                            />
                        </div>
                    );
                } else if (row.Orders[0].Payments?.length === 1) {
                    qbPaymentsButtons = (
                        <div className={"mb-2"}>
                            <OwButton
                                title={"view_payment"}
                                fn={() => {
                                    this.viewPayment(row);
                                }}
                            />
                        </div>
                    );
                }
            }

            if (createInvoiceArea === "shipments" && !shouldHidePricing) {
                if (this.props.userModel.isSupplierUser) {
                    if (!has_invoice && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) {
                        if (
                            !_.isNil(row.Vendor) &&
                            !_.isNil(row.Vendor.Vendor_Integration) &&
                            !_.isNil(row.Vendor.Vendor_Integration.qbo_CustomerId)
                        ) {
                            quickBooksButtons = (
                                <div className={"mb-1"}>
                                    <OwButton
                                        disabled={this.state.disableCreateInvoice[row.guid]}
                                        active={this.state.activeCreateInvoice[row.guid]}
                                        leftIconClass="fas fa-plus"
                                        className="btn-primary mb-2 mb-md-0"
                                        title="create_invoice"
                                        fn={(e: any) => {
                                            this.openInvoiceSidebar(row);
                                        }}
                                    />
                                </div>
                            );
                        } else {
                            const firstOrder = (row.Orders || []).length ? row.Orders![0] : null;

                            if (firstOrder && firstOrder.order_source_id === OrderSourceEnum.ORDERWERKS) {
                                quickBooksButtons = (
                                    <div>
                                        <OwLabel
                                            title={"vendor_not_quickbooks_connected"}
                                            className={"text-muted"}
                                            isSupplierVendorOverride={true}
                                            supplierModel={this.props.supplierModel}
                                        />
                                    </div>
                                );
                            }
                        }
                    }
                }

                if (has_invoice) {
                    quickBooksButtons = (
                        <QBOInvoiceActions
                            disabled={this.state.disableViewInvoice![row.guid]}
                            active={this.state.activeViewInvoice![row.guid]}
                            viewFn={this.viewInvoice}
                            voidFn={this.voidInvoice}
                            deleteFn={this.deleteInvoice}
                            data={row}
                        />
                    );
                }
            }
        }

        if (row.is_local_pickup || row.is_local_delivery) {
            let showButton = false;

            if (this.props.userModel.isSupplierUser) {
                if (
                    this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                    this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT
                ) {
                    showButton = true;
                }
            }

            if (!row.pickup_image_attachment_id) {
                if (showButton) {
                    shippingButtons = (
                        <OwButton
                            className={"btn btn-primary mb-1"}
                            leftIconClass={"fad fa-pen-fancy"}
                            title={"capture_signature"}
                            fn={() => {
                                this.showSignatureModal(row, true);
                            }}
                        />
                    );
                }
            } else {
                shippingButtons = (
                    <OwButton
                        className={"btn btn-primary mb-1"}
                        leftIconClass={"fad fa-signature"}
                        title={"view_signature"}
                        fn={() => {
                            this.showSignatureModal(row, false);
                        }}
                    />
                );
            }
        }

        let wayfairButton: any = null;

        let rowHasShipment = false;

        if (row.Shipments.length) {
            rowHasShipment = true;
        }

        if (row.is_wayfair) {
            if (!row.wayfair_submitted) {
                if (!rowHasShipment) {
                    wayfairButton = <OwLabel title={"one_shipment_required_for_wayfair"} className={"text-danger mt-2"} />;
                } else {
                    wayfairButton = (
                        <OwButton
                            className={"mt-2 btn-primary"}
                            leftIconClass={"fad fa-upload-alt"}
                            title={"send_wayfair_ship_notification"}
                            active={row.guid === this.state.wayfairShipmentGroupRow}
                            disabled={this.state.wayfairIsActive}
                            fn={() => {
                                this.sendWayfairShipNotification(row);
                            }}
                        />
                    );
                }
            } else {
                wayfairButton = <OwLabel className={"text-success"} title={"submitted_to_wayfair"} leftIconClass={"fas fa-check"} />;
            }
        }

        if (!this.props.userModel.isSupplierUser) {
            shippingButtons = null;
            qbPaymentsButtons = null;
            quickBooksButtons = null;
            packingListButton = null;
            bolButton = null;
            wayfairButton = null;
        }

        const buttons = (
            <div>
                <div>
                    <OwLabel title={"created_at"} postText={":"} className={"me-2"} />
                    {UserService.parseDate(row.created_at)}
                </div>
                {shippingButtons} {qbPaymentsButtons} {quickBooksButtons} {packingListButton} {bolButton} {wayfairButton}
            </div>
        );

        return buttons;
    };

    renderDetailView = (options: { parentRowId: string; row: IShipment_GroupUI; parentRowIndex: number }): any => {
        return (
            <div>
                {this.detailViewActionRow(options.row, options.parentRowIndex)}
                <div>
                    <OwTable
                        columns={this.state.detailViewColumns}
                        dataSet={options.row.Shipments}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={false}
                        initialData={false}
                        parentRowIndex={options.parentRowIndex}
                    />
                </div>
            </div>
        );
    };

    detailViewActionRow = (row: IShipment_GroupUI, index: number) => {
        let isShipstationPackage = _.get(row, "shipstation_order_id", false);
        isShipstationPackage = !_.isNil(isShipstationPackage) ? isShipstationPackage : false;

        return (
            <div className={"d-flex align-items-center"}>
                <OwTitle title={"shipments"} tag={"h5"} className={"d-inline-flex me-2"} />
                <div>
                    {this.state.hasEditMode &&
                    this.props.userModel.isSupplierUser &&
                    (this.props.userModel.userType?.id === UserTypesEnum.ADMIN ||
                        this.props.userModel.userType?.id === UserTypesEnum.ORDER_MGMT ||
                        this.props.userModel.userType?.id === UserTypesEnum.SHIP_MGMT ||
                        this.props.userModel.userType?.id === UserTypesEnum.INVENTORY_MGMT) ? (
                        <OwButton
                            leftIconClass={"fas fa-plus"}
                            title={"add_shipment"}
                            className={"btn-secondary btn-sm mb-2"}
                            fn={() => {
                                this.openPackageSidebar(row);
                            }}
                        />
                    ) : null}
                </div>
                {isShipstationPackage &&
                row.Shipments.length &&
                this.props.userModel.isSupplierUser &&
                this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                    <div className={"ms-auto"}>
                        <OwButton
                            fn={(e: any) => {
                                this.viewShipmentGroupLabels(row);
                            }}
                            leftIconClass={"fas fa-eye"}
                            className={"btn-success me-2 mb-2 align-top"}
                            title={"view_all_labels"}
                        />
                        {row.Shipments.length ? (
                            <OwButton
                                fn={(e: any) => {
                                    this.voidShipmentGroupLabels(row);
                                }}
                                leftIconClass={"fas fa-ban"}
                                className={"btn-danger me-2 mb-2 align-top"}
                                title={"void_all_labels"}
                            />
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    };

    showShipmentDeleteModal = (row: IShipmentUI) => {
        const modalComponent = (
            <ConfirmDeleteShipmentModal shipment={row} commitDeleteFn={this.deleteShipment} cancelFn={this.closeModal} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    renderDetailViewActions = (row: IShipmentUI, index: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        // don't allow delete of integration shipments.
        if (row.shipstation_shipmentId) {
            return;
        } else {
            if (
                (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) ||
                this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.SHIP_MGMT ||
                this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.INVENTORY_MGMT
            ) {
                return (
                    <OwDeleteEditActions
                        isEditMode={false}
                        onTrashClickFn={() => {
                            this.showShipmentDeleteModal(row);
                        }}
                        onEditClickFn={() => {}}
                        hideEdit={true}
                    />
                );
            } else {
                return null;
            }
        }
    };

    renderShipDate = (row: IShipmentUI) => {
        let shipment_date;

        if (!_.isNil(row.shipment_date)) {
            shipment_date = UserService.parseDate(row.shipment_date);
        }

        return <div className={row.is_voided ? " text-muted text-strikethrough" : ""}>{shipment_date}</div>;
    };

    getShippingCarrierNameAndLogo = (row: IShipmentUI): { shipping_carrier_name: string; shipping_carrier_logo: any } => {
        let shipping_carrier_name = _.get(row.Shipping_Carrier, "name", "");

        if (!_.isNil(row.shipstation_carrierCode)) {
            shipping_carrier_name = row.shipstation_carrierCode;
        }

        let shipping_carrier_logo: any = null;

        switch (shipping_carrier_name) {
            case "FEDEX":
            case "fedex":
                shipping_carrier_name = "FedEx";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={fedexLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "UPS":
            case "ups":
                shipping_carrier_name = "UPS";
                shipping_carrier_logo = <img src={upsLogo} height={20} title={shipping_carrier_name} />;
                break;

            case "USPS":
            case "usps":
                shipping_carrier_name = "USPS";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={uspsLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "DHL":
            case "dhl":
                shipping_carrier_name = "DHL";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={dhlLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "TNT":
            case "tnt":
                shipping_carrier_name = "TNT";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={tntLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;
        }

        return { shipping_carrier_name, shipping_carrier_logo };
    };

    renderCarrier = (row: IShipmentUI) => {
        const shippingCarrierDetail = this.getShippingCarrierNameAndLogo(row);

        let shipping_carrier_name = shippingCarrierDetail.shipping_carrier_name;
        const shipping_carrier_logo = shippingCarrierDetail.shipping_carrier_logo;

        const shipstationId = row.shipstation_shipmentId;

        let shipstation_logo: any = null;

        if (!_.isNil(shipstationId)) {
            shipping_carrier_name = _.get(row, "shipstation_carrierCode", "");
            shipstation_logo = <img src={shipstationGear} height={20} />;
        }

        return (
            <div>
                {shipping_carrier_logo || shipping_carrier_name} {shipstation_logo}
            </div>
        );
    };

    renderShipmentStatus = (row: IShipmentUI) => {
        if (row.is_voided) {
            return <BetaBadge title={"voided"} />;
        } else {
            let shipment_status_name = _.get(row.Shipment_Status, "name", "");

            shipment_status_name = _.startCase(_.toLower(shipment_status_name));

            return shipment_status_name;
        }
    };

    renderNote = (row: IShipmentUI) => {
        const note = row.note;

        return <div>{note}</div>;
    };

    renderShipmentPrice = (row: IShipmentUI) => {
        return <div>{row.total_cost}</div>;
    };

    renderTracking = (row: IShipmentUI) => {
        const { shipping_carrier_name, shipping_carrier_logo } = this.getShippingCarrierNameAndLogo(row);

        return <ShipmentTracking tracking={row.tracking} service={shipping_carrier_name} isVoided={row.is_voided} />;
    };

    renderPackingList = (row: IShipmentUI) => {
        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        return <Link to={`/packing_lists/${row.Packing_List?.guid}`}>{row.Packing_List?.name}</Link>;
    };

    renderShipmentBtns = (row: IShipmentUI) => {
        let shippingButtons;

        const shipstation_labelData = _.get(row, "shipstation_labelData", undefined);

        const shipment_status_id = _.get(row.Shipment_Status, "id", 100);

        const { shipping_carrier_name, shipping_carrier_logo } = this.getShippingCarrierNameAndLogo(row);

        let voidShipmentBtn: any = null;
        let voidShipstationBtn: any = null;
        let completeShipmentBtn: any = null;
        let viewLabelBtn: any = null;

        if ((shipment_status_id < ShipmentStatusEnum.PARTIALLY_SHIPPED || shipping_carrier_name === "LOCAL") && this.state.hasEditMode) {
            voidShipmentBtn = this.props.userModel.isSupplierUser ? (
                <OwButton
                    title={"void"}
                    className={"btn-danger"}
                    leftIconClass={"fas fa-ban"}
                    fn={(e: any) => {
                        this.voidShipment(row);
                    }}
                />
            ) : null;
        }

        if (row.shipstation_shipmentId && !row.is_voided) {
            voidShipstationBtn = this.props.userModel.isSupplierUser ? (
                <OwButton
                    title={"void"}
                    className={"btn-danger"}
                    leftIconClass={"fas fa-ban"}
                    fn={(e: any) => {
                        this.voidShipstationLabel(row);
                    }}
                />
            ) : null;
        }

        if (shipment_status_id === ShipmentStatusEnum.READY_FOR_PICKUP) {
            completeShipmentBtn = this.props.userModel.isSupplierUser ? (
                <OwButton
                    className={"btn-success me-2 mb-2"}
                    fn={(e: any) => {
                        this.completeShipment(row);
                    }}
                    leftIconClass={"fas fa-check"}
                    title={"complete"}
                />
            ) : null;
        }

        if (!_.isNil(shipstation_labelData) || (!_.isNil(row.label_attachment_id) && !row.is_voided)) {
            viewLabelBtn = (
                <OwButton
                    fn={(e: any) => {
                        this.viewLabel(row);
                    }}
                    leftIconClass={"fas fa-eye"}
                    className={"btn-success me-2 mb-2 align-top"}
                    title={"view_label"}
                    active={this.state.resendEmailActive}
                    disableOnActive={true}
                />
            );
        }

        const resendShipmentEmailBtn = (
            <OwButton
                className={"ms-2 btn-primary"}
                title={"resend_email"}
                leftIconClass={"fas fa-envelope"}
                fn={() => {
                    this.resendEmail(row);
                }}
            />
        );

        return (
            <div>
                {completeShipmentBtn} {viewLabelBtn} {voidShipstationBtn || voidShipmentBtn} {resendShipmentEmailBtn}
            </div>
        );
    };

    parseUrlForFilter = () => {
        const parsedSearch = qs.parse(this.props.location.search);

        const order = _.get(parsedSearch, "order", undefined);

        return order;
    };

    parseUrlForActions = () => {
        const parsedSearch = qs.parse(this.props.location.search);

        const action = _.get(parsedSearch, "action", undefined);

        let details: any;

        switch (action) {
            case "new_shipment":
                {
                    details = {};
                    let vendor_name: string | undefined = _.get(parsedSearch, "vendor_name", undefined);
                    let order_name: string | undefined = _.get(parsedSearch, "order_name", undefined);

                    const is_local_pickup: boolean = _.get(parsedSearch, "is_local_pickup", false) === "false";
                    const is_local_delivery: boolean = _.get(parsedSearch, "is_local_delivery", false) === "false";
                    const is_dropshipment: boolean = _.get(parsedSearch, "is_dropshipment", false) === "false";

                    if (!_.isNil(vendor_name)) {
                        vendor_name = decodeURI(vendor_name);
                    }

                    if (!_.isNil(order_name)) {
                        order_name = decodeURI(order_name);
                    }

                    details.type = "new_shipment";
                    details.vendor_guid = _.get(parsedSearch, "vendor_guid", undefined);
                    details.vendor_name = vendor_name;
                    details.order_guid = _.get(parsedSearch, "order_guid", undefined);
                    details.order_name = order_name;
                    details.is_local_delivery = is_local_delivery;
                    details.is_local_pickup = is_local_pickup;
                    details.is_dropshipment = is_dropshipment;
                }
                break;
        }

        return details;
    };

    toggleVoided = () => {
        this.setState({
            showVoided: !this.state.showVoided,
        });
    };

    getShipmentGroups = () => {
        console.log(
            "getShipmentGroups: ",
            this.props.userModel,
            this.props.supplierModel,
            this.state.vendorModel,
            this.state.isDataFetching
        );
        if (!this.props.userModel || !this.props.supplierModel || !this.state.vendorModel || this.state.isDataFetching) {
            return;
        }

        const data: any = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: this.state.queryString,
            offset: this.state.offset,
            limit: this.state.limit,
        };

        if (this.props.userModel.isSupplierUser) {
            data.supplierGuid = this.props.supplierModel.guid;
        } else {
            data.vendorGuid = this.state.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.ShipmentGetShipmentGroups, data);

        this.setState({
            isDataFetching: true,
            isLoadingShipments: true,
            activeCreateInvoice: {},
            disableCreateInvoice: {},
            activeViewInvoice: {},
            disableViewInvoice: {},
        });
    };

    onGetShipmentGroups = (data: any) => {
        const shipmentGroups = _.each(data.shipmentGroups, (shipmentGroup) => {
            shipmentGroup.isSaved = true;
        });

        const totalShipmentGroups = data.totalShipmentGroups;

        this.setState(
            {
                shipmentGroups,
                totalShipmentGroups,
                isLoadingShipments: false,
                isDataFetching: false,
                isInitialData: false,
            },
            () => {
                this.props.setActivityIndicator(false);
            }
        );
    };

    onVoidShipment = (data: IOnVoidShipmentDTO) => {
        const notification = {
            message: "SUCCESSFULLY VOIDED SHIPMENT",
            level: "success",
            position: "br",
        };

        this.props.notifyFn(null, notification);

        this.getShipmentGroups();
    };

    onDeleteShipmentGroup = (data: IOnDeleteShipmentGroupDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_shipment_group",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        const state: any = {
            sourceGroupElem: null,
            selectedShipmentGroup: null,
        };

        this.setState(state, () => {
            this.getShipmentGroups();
        });
    };

    deleteShipment = (shipment: IShipment) => {
        const payload: IDeleteShipmentDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGuid: shipment.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentDeleteShipment, payload);

        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                this.props.setActivityIndicator(true);
            }
        );
    };

    onDeleteShipment = () => {
        console.log("onDeleteShipment");
        this.props.setActivityIndicator(false);

        this.getShipmentGroups();
    };

    getShipmentGroupSidebar = (shipmentGroup?: IShipment_GroupUI) => {
        if (!_.isNil(shipmentGroup) && _.isNil(shipmentGroup.action)) {
            // this action thing might need to be re-thought?

            shipmentGroup.action = {
                type: "existing_shipment",
            };
        }

        return <ShipmentGroupSidebarFn cancel={this.cancel} shipmentGroup={shipmentGroup} />;
    };

    getInvoiceSidebarComponent = (shipment: any) => {
        return (
            <QuickBooksOnlineInvoiceSidebar
                shipmentGroup={shipment}
                saveFn={this.createInvoice}
                cancelFn={this.cancel}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
            />
        );
    };

    cancel = (refresh?: boolean) => {
        this.props.toggleSidebar();

        if (refresh) {
            if (window.location.href.indexOf("new_shipment") > -1) {
                if (window.location.href.indexOf("ecomm") > -1) {
                    this.props.history("/ecomm/shipments");
                } else {
                    this.props.history("/shipments");
                }
            }

            this.getShipmentGroups();
        }
    };

    voidShipment = (shipment: any) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const data = {
            userGuid: this.props.userModel.guid,
            token: this.props.userModel.token,
            vendorGuid: shipment.Vendor.guid,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGuid: shipment.guid,
        };

        this.props.socket.emit("voidShipment", data);
    };

    voidShipstationLabel = (row: IShipmentUI) => {
        if (!row.shipstation_shipmentId || !this.props.userModel) {
            return;
        }

        const data: IShipstationVoidLabelDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipmentId: Number(row.shipstation_shipmentId),
        };

        this.props.socket.emit(EndpointsEnum.ShipstationVoidLabel, data);
    };

    onVoidShipstationLabel = (data: IOnShipstationVoidLabelDTO) => {
        const notification: INotification = {
            message: "successfully_voided_shipstation_label",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getShipmentGroups();
    };

    toggleConfirmDelete = (e: any, data: any, index: number) => {
        const row = document.getElementById(`row-${index}`);

        console.log(row);

        if (row) {
            const state: any = {
                targetElem: `row-${index}`,
                sourceGroupElem: row,
                selectedShipmentGroup: data,
            };

            this.setState(state);
        }
    };

    deleteShipmentGroup = (shipmentGroup: any) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const data: IDeleteShipmentGroupDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGroupGuid: shipmentGroup.guid,
            delete_shipstation_order: !!this.state.delete_shipstation_order,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentDeleteShipmentGroup, data);

        const state: any = {
            sourceGroupElem: null,
            selectedShipmentElem: null,
            targetElem: null,
        };

        this.setState(state);
    };

    commitDelete = () => {
        if (this.state.selectedShipmentGroup) {
            this.deleteShipmentGroup(this.state.selectedShipmentGroup);
        }
    };

    cancelDelete = () => {
        const state: any = {
            sourceGroupElem: null,
            selectedShipmentElem: null,
            targetElem: null,
        };

        this.setState(state);
    };

    completeShipment = (shipment: any) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const data = {
            userGuid: this.props.userModel.guid,
            token: this.props.userModel.token,
            vendorGuid: shipment.Vendor.guid,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGuid: shipment.guid,
            shipment_status_id: ShipmentStatusEnum.COMPLETED,
        };

        this.props.socket.emit("updateShipmentStatus", data);
    };

    onUpdateShipmentStatus = (shipment: any) => {
        this.getShipmentGroups();
    };

    /**
     * Opens the Sidebar to either Create or Edit a shipment
     *
     * @param {*} shipment      If editing a shipment, the shipment object
     */
    openShipmentGroupSidebar = (shipmentGroup?: IShipment_GroupUI, index?: number) => {
        const sidebarComp = this.getShipmentGroupSidebar(shipmentGroup);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar(true);
    };

    openInvoiceSidebar = (shipment: any, index?: number) => {
        const sidebarComp = this.getInvoiceSidebarComponent(shipment);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar(true);
    };

    getPdfInvoiceSidebar = (invoiceUInt8ArrayData: any) => {
        const activeShipment = this.state.activeViewInvoice;

        if (!activeShipment) {
            return null;
        }

        const keysArr = Object.keys(activeShipment);

        const shipmentGroupGuid = keysArr[0];

        const shipmentGroupModel = _.find(this.state.shipmentGroups, (shipmentGroup) => {
            return shipmentGroup.guid === shipmentGroupGuid;
        });

        if (!shipmentGroupModel) {
            return null;
        }

        // console.log('activeShipment', activeShipment);

        return (
            <PdfSidebarViewer
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                shipmentGuid={shipmentGroupGuid}
                shipmentGroupModel={shipmentGroupModel}
                file={invoiceUInt8ArrayData}
                cancel={this.cancel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                qboInvoiceTotal={Number(shipmentGroupModel.qbo_InvoiceTotal || 0)}
                qboInvoiceId={shipmentGroupModel.qbo_InvoiceId!}
                qboEntityId={shipmentGroupModel.qbo_EntityId!}
                qboVendorEmail={shipmentGroupModel!.Vendor!.Vendor_Integration!.qbo_Email || "-"}
                vendorEmail={shipmentGroupModel!.Vendor!.email}
                vendorGuid={shipmentGroupModel!.Vendor!.guid}
            />
        );
    };

    openPdfInvoiceSidebar = (invoiceUInt8ArrayData: any) => {
        const sidebarComp = this.getPdfInvoiceSidebar(invoiceUInt8ArrayData);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();

        // set all to false...
        this.setState({
            disableViewInvoice: {},
            activeViewInvoice: {},
        });
    };

    processDate = (date: any) => {
        const dateVal = UserService.parseLastUpdated(date);

        if (dateVal === "Invalid date") {
            return "";
        } else {
            return dateVal;
        }
    };

    resendEmail = (shipment: IShipment) => {
        const payload: IResendShipmentEmailDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGuid: shipment.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentResendShipmentEmail, payload);

        this.setState({
            resendEmailActive: true,
        });
    };

    viewLabel = (shipment: IShipment) => {
        const shipstation_labelData = _.get(shipment, "shipstation_labelData", undefined);

        if (shipstation_labelData || shipment.Label) {
            const filename = _.get(shipment, "tracking", undefined);
            const shipment_guid = _.get(shipment, "guid", undefined);
            const shipment_name = _.get(shipment, "guid", undefined);
            const token = this.props.userModel.token;

            if (!_.isNil(shipstation_labelData) || shipment.Label) {
                const baseUrl = SocketService.getEndpointUrl();
                const url = `${baseUrl}/shipstation/label/${shipment_guid}/${filename}?token=${token}`;
                window.open(url);
            }
        } else {
            if (shipment.Label) {
                // let signedUrl = shipment.Label.signedUrl;
                // if (signedUrl) {
                //     window.open(signedUrl);
                //     // const modalComponent = (<ViewLabelModal
                //     //     closeModalFn={this.closeModal}
                //     //     socket={this.props.socket}
                //     //     notifyFn={this.props.notifyFn}
                //     //     userModel={this.props.userModel}
                //     //     supplierModel={this.props.supplierModel}
                //     //     signedUrl={signedUrl}/>);
                //     //
                //     // this.setState({
                //     //     modalComponent,
                //     //     modalIsOpen: true,
                //     // });
                // }
            }
        }
    };

    viewShipmentGroupLabels = (shipmentGroup: any) => {
        const shipment_group_guid = _.get(shipmentGroup, "guid", undefined);
        const token = _.get(this.props, "userModel.token", undefined);

        const baseUrl = SocketService.getEndpointUrl();
        const url = `${baseUrl}/shipstation/labels/view-all/${shipment_group_guid}/labels?token=${token}`;
        window.open(url);
    };

    voidShipmentGroupLabels = (shipmentGroup: IShipment_GroupUI) => {
        const component = (
            <VoidLabelsModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                shipmentGroup={shipmentGroup}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    /**
     * Create the QBO Invoice
     *
     * @param shipmentGroup
     * @param invoiceDate       Format as 'YYYY-MM-DD'
     */
    createInvoice = (shipmentGroup: IShipment_GroupUI, invoiceDate: string, shipVia: string, trackingNo: string, shipDate: string) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const shipmentGroupGuid = shipmentGroup.guid;
        const shippingCost = shipmentGroup.shipping_cost;

        const payload: IQBOCreateInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: shipmentGroup.Vendor?.guid,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGroupGuid,
            shippingCost,
            invoiceDate,
        };

        if (shipVia.length) {
            payload.shipMethodRef = shipVia;
        }

        if (trackingNo.length) {
            payload.trackingNo = trackingNo;
        }

        if (shipDate.length) {
            payload.shipDate = shipDate;
        }

        this.props.socket.emit(EndpointsEnum.QBOCreateInvoice, payload);

        const state: any = {
            createShipmentGroup: shipmentGroup,
            disableCreateInvoice: {
                [shipmentGroupGuid]: true,
            },
            activeCreateInvoice: {
                [shipmentGroupGuid]: true,
            },
        };

        this.setState(state);
    };

    onQboCreateInvoice = (data: any) => {
        this.cancel(true);

        this.viewInvoice(this.state.createShipmentGroup);
    };

    viewInvoice = (shipmentGroup: any) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const shipmentGroupGuid = shipmentGroup.guid;

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: shipmentGroup.Vendor.guid,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGroupGuid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetPDFInvoice, payload);

        this.setState({
            activeViewInvoice: {
                [shipmentGroupGuid]: true,
            },
            disableViewInvoice: {
                [shipmentGroupGuid]: true,
            },
        });
    };

    deleteInvoice = (shipmentGroup: IShipment_Group) => {
        if (!this.props.userModel || !this.props.supplierModel || !shipmentGroup.qbo_EntityId) {
            return;
        }

        const shipmentGroupGuid = shipmentGroup.guid;

        const payload: IQBODeleteInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: shipmentGroup.Vendor!.guid,
            supplierGuid: this.props.supplierModel.guid,
            qbo_EntityId: shipmentGroup.qbo_EntityId,
        };

        this.props.socket.emit(EndpointsEnum.QBODeleteInvoice, payload);

        this.setState({
            activeViewInvoice: {
                [shipmentGroupGuid]: true,
            },
            disableViewInvoice: {
                [shipmentGroupGuid]: true,
            },
        });
    };

    onDeleteQboInvoice = (data: IOnQBODeleteInvoiceDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_invoice",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                activeViewInvoice: {},
                disableViewInvoice: {},
            },
            () => {
                this.getShipmentGroups();
            }
        );
    };

    voidInvoice = (shipmentGroup: IShipment_Group) => {
        if (!this.props.userModel || !this.props.supplierModel || !shipmentGroup.qbo_EntityId) {
            return;
        }

        const shipmentGroupGuid = shipmentGroup.guid;

        const payload: IQBOVoidInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: shipmentGroup.Vendor!.guid,
            supplierGuid: this.props.supplierModel.guid,
            qbo_EntityId: shipmentGroup.qbo_EntityId,
        };

        this.props.socket.emit(EndpointsEnum.QBOVoidInvoice, payload);

        this.setState({
            activeViewInvoice: {
                [shipmentGroupGuid]: true,
            },
            disableViewInvoice: {
                [shipmentGroupGuid]: true,
            },
        });
    };

    onVoidQboInvoice = (data: IOnQBOVoidInvoiceDTO) => {
        const notification: INotification = {
            message: "successfully_voided_invoice",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                activeViewInvoice: {},
                disableViewInvoice: {},
            },
            () => {
                this.getShipmentGroups();
            }
        );
    };

    onQboGetPdfInvoice = (data: IQBOOnGetPDFInvoiceDTO) => {
        const sideBarOpenState = this.props.getSidebarState();

        if (!_.isNil(data.data) && !sideBarOpenState) {
            this.openPdfInvoiceSidebar(data.data);
        }
    };

    getShipmentPackageComponent = (shipmentGroup: IShipment_Group, shipment?: IShipment) => {
        return (
            <ShipmentPackageSidebar
                cancel={this.cancel}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                shipmentGroup={shipmentGroup}
                shipment={shipment}
                processedFn={this.processedShipment}
                onUpdateFn={this.updatedShipment}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );
    };

    processedShipment = (shipmentGroup: any, data: any) => {
        let shipment;
        let index;

        _.each(this.state.shipmentGroups, (_shipmentGroup, _index) => {
            if (_shipmentGroup.guid === shipmentGroup.guid) {
                index = _index;
                shipment = _shipmentGroup;
            }
        });

        if (!_.isNil(index)) {
            const shipmentGroups = this.state.shipmentGroups;

            if (_.isNil(shipmentGroups[index].Shipments)) {
                shipmentGroups[index].Shipments = [];
            }

            shipmentGroups[index].Shipments.push(data.shipment);

            this.setState({ shipmentGroups });
        }
    };

    updatedShipment = (shipmentGroup: any, data: any) => {
        let foundShipmentGroup: any = {};
        let index;
        const shipment = data.shipment;
        let shipmentIndex;

        _.each(this.state.shipmentGroups, (_shipmentGroup, _index) => {
            if (_shipmentGroup.guid === shipmentGroup.guid) {
                index = _index;
                foundShipmentGroup = _shipmentGroup;
            }
        });

        _.each(foundShipmentGroup.Shipments, (_shipment, _index) => {
            if (_shipment.guid === shipment.guid) {
                shipmentIndex = _index;
            }
        });

        if (!_.isNil(index) && !_.isNil(shipmentIndex)) {
            const shipmentGroups = this.state.shipmentGroups;

            shipmentGroups[index].Shipments[shipmentIndex] = shipment;

            this.setState({ shipmentGroups });
        }
    };

    openPackageSidebar = (shipmentGroup: IShipment_Group, shipment?: IShipment) => {
        const sidebarComp = this.getShipmentPackageComponent(shipmentGroup, shipment);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar(true);
    };

    toggleNote = (shipmentGroup: any, shipment: any, index?: number) => {
        const shipmentGroups = this.state.shipmentGroups;

        for (let i = 0; i < shipmentGroups.length; ++i) {
            const _shipmentGroup = shipmentGroups[i];

            if (_shipmentGroup.guid === shipmentGroup.guid) {
                for (let j = 0; j < _shipmentGroup.Shipments.length; ++j) {
                    const _shipment = _shipmentGroup.Shipments[j];

                    if (_shipment.guid === shipment.guid) {
                        shipmentGroups[i].Shipments[j].toggleNote = !shipmentGroups[i].Shipments[j].toggleNote;
                    }
                }
            }
        }

        this.setState({
            shipmentGroups,
        });
    };

    getShipmentActionButtons = (shipmentGroup: any, shipment: any, index: number) => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const sideBarOpenIcon = "fa-pencil";

        let note = _.get(shipment, "note", "");
        note = _.isNil(note) ? "" : note;

        return (
            <div>
                {this.state.hasEditMode ? (
                    <a
                        href="javascript:;"
                        role="button"
                        className={`fas pointer ${sideBarOpenIcon}` + (this.props.userModel.isSupplierUser ? " " : " d-none")}
                        onClick={() => {
                            this.openPackageSidebar(shipmentGroup, shipment);
                        }}
                    />
                ) : null}
                <a
                    href="javascript:;"
                    role="button"
                    className={`ms-2 fas pointer fa-sticky-note ` + (note.length ? "" : "d-none")}
                    title={note}
                    onClick={() => {
                        this.toggleNote(shipmentGroup, shipment, index);
                    }}
                />
            </div>
        );
    };

    getPackages = (shipmentGroup: any) => {
        const packages = _.map(shipmentGroup.Shipments, (shipment: any, index: number) => {
            let shippingButtons;
            let isShipstationShipment = false;

            const shipment_status_id = _.get(shipment.Shipment_Status, "id", 100);
            let shipping_carrier_name: any = _.get(shipment.Shipping_Carrier, "name", "");
            const shipstation_labelData = _.get(shipment, "shipstation_labelData", undefined);

            let shipstation_logo: any = null;

            if (
                (shipment_status_id < ShipmentStatusEnum.PARTIALLY_SHIPPED || shipping_carrier_name === "LOCAL") &&
                this.state.hasEditMode
            ) {
                shippingButtons = (
                    <OwButton
                        title={"void"}
                        className={"btn-danger"}
                        leftIconClass={"fas fa-ban"}
                        fn={(e: any) => {
                            this.voidShipment(shipment);
                        }}
                    />
                );
                // shippingButtons = (<button type="button" className="btn btn-danger btn-sm me-2 mb-2" onClick={(e) => { this.voidShipment(shipment); }}><i className="fas fa-ban"></i> Void</button>);
                {
                    /*<button type="button" className="btn btn-warning btn-sm"><i className="fas fa-search-location"></i> Track</button>*/
                }
            }

            if (shipment_status_id === ShipmentStatusEnum.READY_FOR_PICKUP) {
                shippingButtons = (
                    <OwButton
                        className={"btn-success me-2 mb-2"}
                        fn={(e: any) => {
                            this.completeShipment(shipment);
                        }}
                        leftIconClass={"fas fa-check"}
                        title={"complete"}
                    />
                );
            }

            if (!_.isNil(shipstation_labelData)) {
                isShipstationShipment = true;

                shippingButtons = (
                    <OwButton
                        fn={(e: any) => {
                            this.viewLabel(shipment);
                        }}
                        leftIconClass={"fas fa-eye"}
                        className={"btn-success me-2 mb-2 align-top"}
                        title={"view_label"}
                    />
                );

                shipping_carrier_name = _.get(shipment, "shipstation_carrierCode", "");
                shipstation_logo = <img src={shipstationGear} height={20} />;
            }

            let shipment_date;

            if (!_.isNil(shipment.shipment_date)) {
                shipment_date = UserService.parseDate(shipment.shipment_date);
            }

            let shipping_carrier_logo: any = null;

            switch (shipping_carrier_name) {
                case "FEDEX":
                case "fedex":
                    shipping_carrier_name = "FedEx";
                    shipping_carrier_logo = (
                        <img
                            style={{
                                backgroundColor: "white",
                                padding: "3px",
                                borderRadius: "3px",
                            }}
                            src={fedexLogo}
                            height={20}
                            title={shipping_carrier_name}
                        />
                    );
                    break;

                case "UPS":
                case "ups":
                    shipping_carrier_name = "UPS";
                    shipping_carrier_logo = <img src={upsLogo} height={20} title={shipping_carrier_name} />;
                    break;

                case "USPS":
                case "usps":
                    shipping_carrier_name = "USPS";
                    shipping_carrier_logo = (
                        <img
                            style={{
                                backgroundColor: "white",
                                padding: "3px",
                                borderRadius: "3px",
                            }}
                            src={uspsLogo}
                            height={20}
                            title={shipping_carrier_name}
                        />
                    );
                    break;

                case "DHL":
                case "dhl":
                    shipping_carrier_name = "DHL";
                    shipping_carrier_logo = (
                        <img
                            style={{
                                backgroundColor: "white",
                                padding: "3px",
                                borderRadius: "3px",
                            }}
                            src={dhlLogo}
                            height={20}
                            title={shipping_carrier_name}
                        />
                    );
                    break;

                case "TNT":
                case "tnt":
                    shipping_carrier_name = "TNT";
                    shipping_carrier_logo = (
                        <img
                            style={{
                                backgroundColor: "white",
                                padding: "3px",
                                borderRadius: "3px",
                            }}
                            src={tntLogo}
                            height={20}
                            title={shipping_carrier_name}
                        />
                    );
                    break;
            }

            let shipment_status_name = _.get(shipment.Shipment_Status, "name", "");

            shipment_status_name = _.startCase(_.toLower(shipment_status_name));

            let shipmentActionButtons: any = this.getShipmentActionButtons(shipmentGroup, shipment, index);

            if (!_.isNil(shipment.is_voided) && shipment.is_voided) {
                shippingButtons = null;
                shipment_status_name = <BetaBadge title={"voided"} />;
                shipment_date = "";
                shipmentActionButtons = null;
            }

            let shipmentNote = _.get(shipment, "note", "");
            shipmentNote = _.isNil(shipmentNote) ? "" : shipmentNote;

            return (
                <tbody key={shipment.guid}>
                    <tr>
                        <td>{shipmentActionButtons}</td>
                        <td>{shipment_date}</td>
                        <td>
                            {shipping_carrier_logo || shipping_carrier_name} {shipstation_logo}
                        </td>
                        <td>{shipment_status_name}</td>
                        <td>
                            {shipment.is_voided ? null : <ShipmentTracking tracking={shipment.tracking} service={shipping_carrier_name} />}
                        </td>
                        <td>{shippingButtons}</td>
                    </tr>
                    <tr className={shipmentNote.length && shipment.toggleNote ? "" : "d-none"}>
                        <td colSpan={6}>
                            <b>
                                <OwLabel title={"note"} className={"me-2 text-bold"} />
                            </b>
                            {shipmentNote}
                        </td>
                    </tr>
                </tbody>
            );
        });

        return packages;
    };

    shouldHidePricing = (): boolean => {
        return UserService.hidePricing(this.props.supplierModel, this.props.userModel, this.props.vendorModel);
    };

    /** Whether this user sees the FilterBar (v2) instead of the legacy search section. Ecommerce always uses legacy. */
    usesFilterBarV2 = (): boolean => {
        return getFilterBarMode(UserService.getCurrentToken(this.props.userModel)?.settings, { forceLegacy: this.props.isEcommerce })
            .useFilterBar;
    };

    filterShipments = (queryString: string) => {
        this.setState(
            {
                queryString,
                offset: 0,
            },
            () => {
                this.getShipmentGroups();
            }
        );
    };

    getQueryString = (search: {
        packing_list?: string;
        order?: string;
        po_no?: string;
        vendor?: string;
        has_shipments?: string;
        hide_signed?: boolean;
        offset?: number;
        limit?: number;
        shipment_type?: string;
    }): string => {
        const query: string[] = [];
        let queryString = "";

        if (!_.isNil(search.vendor) && search.vendor.length) {
            query.push(`vendor=${search.vendor}`);
        }

        if (!_.isNil(search.order) && search.order.length) {
            query.push(`order=${search.order}`);
        }

        if (!_.isNil(search.po_no) && search.po_no.length) {
            query.push(`po_no=${search.po_no}`);
        }

        if (!_.isNil(search.packing_list) && search.packing_list.length) {
            query.push(`packing_list=${search.packing_list}`);
        }

        if (!_.isNil(search.has_shipments)) {
            query.push(`has_shipments=${search.has_shipments}`);
        }

        if (!_.isNil(search.hide_signed)) {
            query.push(`hide_signed=${search.hide_signed}`);
        }

        if (!_.isNil(search.offset)) {
            query.push(`offset=${search.offset}`);
        }

        if (!_.isNil(search.limit)) {
            query.push(`limit=${search.limit}`);
        }

        if (!_.isNil(search.shipment_type) && search.shipment_type.length) {
            query.push(`shipment_type=${search.shipment_type}`);
        }

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        return queryString;
    };

    getParamsState = (
        location: any
    ): {
        packing_list: string;
        order: string;
        po_no: string;
        vendor: string;
        has_shipments: string;
        hide_signed: boolean;
        offset: number;
        limit: number;
        shipment_type: string;
    } => {
        const params = new URLSearchParams(location.search);

        let stateOffset: number | undefined;
        let stateLimit: number | undefined;

        if (this.state) {
            stateOffset = this.state.offset;
            stateLimit = this.state.limit;
        }

        const packing_list = params.get("packing_list") || "";
        const order = params.get("order") || "";
        const po_no = params.get("po_no") || "";
        const vendor = params.get("vendor") || "";
        let offset = Number(params.get("offset") || 0);
        const limit = Number(stateLimit || params.get("limit") || 5);
        const has_shipments = params.get("has_shipments") || "";
        const hide_signed = params.get("hide_signed") === "true" || false;
        const shipment_type = params.get("shipment_type") || "";

        if (this.state?.offset >= 0) {
            offset = this.state.offset;
        }

        return { packing_list, order, po_no, vendor, has_shipments, hide_signed, offset, limit, shipment_type };
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                const pathname = this.props.location.pathname;
                const paramsState = this.getParamsState(this.props.location);

                const queryString = this.getQueryString(paramsState);

                // console.log(pathname, paramsState);
                this.props.history({
                    pathname,
                    search: queryString,
                });

                this.getShipmentGroups();
            }
        );
    };

    onDocumentLoadSuccess = (data: any) => {
        console.log("onDocumentLoadSuccess", data);
    };

    onDocumentLoadError = (data: any) => {
        console.log("onDocumentLoadError", data);
    };

    onDocumentSourceError = (data: any) => {
        console.log("onDocumentSourceError", data);
    };

    onDocumentSourceSuccess = (data: any) => {
        console.log("onDocumentSourceSuccess", data);
    };

    afterOpenModal = () => {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    };

    closeModal = (refresh?: boolean) => {
        this.props.uiContext.setModalComponent(null);
        this.props.uiContext.showModal(false);

        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (refresh) {
                    this.getShipmentGroups();
                }
            }
        );
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    showFishbowlDownloadShipmentsModal = () => {
        const component = (
            <FishbowlDownloadShipmentsModal closeModalFn={this.closeModal} socket={this.props.socket} notifyFn={this.props.notifyFn} />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    render() {
        let createButton: any = null;

        if (!_.isNil(this.props.userModel) && this.props.userModel.isSupplierUser && this.state.hasEditMode) {
            createButton = (
                <OwButton
                    id={"createButton"}
                    fn={() => {
                        this.openShipmentGroupSidebar();
                    }}
                    leftIconClass={"fas fa-plus"}
                    title={"create"}
                    className={"ms-2 btn-warning"}
                />
            );
        }

        let shipmentGroupHasItems = false;

        if (this.state.shipmentGroups && this.state.shipmentGroups.length) {
            shipmentGroupHasItems = true;
        }

        return (
            <div className="Shipments position-relative">
                <div className="row mt-2">
                    <div className="col-12 d-flex align-items-center justify-items-center">
                        <OwTitle className={"me-2"} title="shipments" leftIconName="fad fa-box me-2" />
                        {createButton}
                        {this.state.showHiddenFeatures && this.props.supplierModel.Supplier_Integration.has_fishbowl ? (
                            <div>
                                <OwButton title={"download_shipments"} fn={this.showFishbowlDownloadShipmentsModal} />
                            </div>
                        ) : null}
                        {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons */}
                        <div className={"ms-auto d-flex align-items-center"}>
                            <FilterBarVersionToggle forceLegacy={this.props.isEcommerce} />
                            <div id={"shipments-filter-actions"} className={"d-flex align-items-center ms-2 d-print-none"} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        {this.usesFilterBarV2() ? (
                            <ShipmentsFilterBar isSearching={this.state.isDataFetching} searchFn={this.filterShipments} />
                        ) : (
                            <SearchSection>
                                <ShipmentFilterFn
                                    order={this.state.orderFilter}
                                    searchFn={this.filterShipments}
                                    getParamsState={this.getParamsState}
                                    getQueryString={this.getQueryString}
                                />
                            </SearchSection>
                        )}
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        <OwActionBar
                            toggleSmallTable={() => {}}
                            colToggledFn={() => {}}
                            columns={{}}
                            totalValue={this.state.totalShipmentGroups}
                            hideColumnToggle={true}
                            hideTableTypeSelect={true}
                        />
                    </div>

                    <div className={"col-12 position-relative"}>
                        <ConfirmDeleteOverlayFn
                            targetElem={this.state.targetElem}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            nestedParentElem={"shipments-table"}
                            skipMainView={true}
                            leftAdjustment={-12}
                        />

                        <OwFnTable
                            id={"shipments-table"}
                            wrappingClassName={"table-responsive"}
                            columns={this.state.columns}
                            dataSet={this.state.shipmentGroups}
                            isDetailViewTable={true}
                            detailViewComponent={this.renderDetailView}
                            dataFetch={this.state.isDataFetching}
                            initialData={this.state.isInitialData}
                            tableConfig={{ tableStriped: true, hasDetailView: true, tableHover: false, detailViewFullWidth: true }}
                            initialDetailViewVisible={this.state.shipmentGroups.length === 1}
                        />

                        {shipmentGroupHasItems ? (
                            <PaginationBar
                                offset={this.state.offset}
                                limit={this.state.limit}
                                totalRecords={this.state.totalShipmentGroups!}
                                onPaginationChanged={this.paginationChanged}
                            />
                        ) : null}
                    </div>
                </div>

                <div className="overlayRow justify-content-center align-items-start flex-column">{this.state.overlayRow}</div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={(e: any) => {
                        this.closeModal();
                    }}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}
                    style={{}}>
                    {this.state.modalComponent}
                </Modal>
            </div>
        );
    }
}

export default Shipments;
